<template>
  <v-navigation-drawer app clipped v-model="drawer">
    <v-list dense>
      <template v-for="(item, i) in itens">
        <v-list-item
          v-if="item.submenus && item.submenus.length === 0 && permitido(item)"
          :key="`menu-item-${i}`"
          :to="item.route"
          :group="item.grupo"
        >
          <v-list-item-icon v-if="item.icon">
            <v-icon :class="item.icon" />
          </v-list-item-icon>
          <v-list-item-title>{{ item.texto }}</v-list-item-title>
        </v-list-item>
        <v-list-group
          v-if="item.submenus && item.submenus.length > 0 && permitido(item)"
          :key="`menu-item-${i}`"
          :prepend-icon="item.icon"
        >
          <template v-slot:activator>
            <v-list-item-title>{{ item.texto }}</v-list-item-title>
          </template>
          <template v-for="(subitem, j) in item.submenus">
            <v-menu
              v-if="subitem.submenus && subitem.submenus.length > 0 && permitido(subitem)"
              :key="`dropdown-${i}-${j}`"
              nudge-bottom="35"
              nudge-right="35"
              right
            >
              <template v-slot:activator="{on}">
                <v-list-item v-on="on">
                  <v-list-item-title class="pl-5">{{ subitem.texto }}</v-list-item-title>
                  <v-list-item-icon>
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </template>
              <v-list dense>
                <template v-for="(dItem, k) in subitem.submenus">
                  <v-list-item
                    :key="`ddown-item-${i}-${j}-${k}`"
                    v-if="permitido(dItem)"
                    :to="dItem.route"
                  >
                    <v-list-item-icon v-if="dItem.icon">
                      <v-icon>{{dItem.icon}}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{dItem.texto}}</v-list-item-title>
                  </v-list-item>
                </template>
              </v-list>
            </v-menu>
            <v-list-item
              v-else-if="permitido(subitem)"
              :key="`submenu-item-${i}-${j}`"
              :to="subitem.route"
              :group="subitem.grupo"
            >
              <v-list-item-title class="pl-5">{{ subitem.texto }}</v-list-item-title>
              <v-list-item-icon v-if="subitem.icon">
                <v-icon :class="subitem.icon" />
              </v-list-item-icon>
            </v-list-item>
          </template>
        </v-list-group>
      </template>
    </v-list>
    <template v-slot:append>
      <v-divider />
      <div class="text-center py-1 d3v-link">
        <a href="http://d3v.com.br" target="_blank">D3V Tecnologia</a>
        &nbsp;&nbsp; | &nbsp;&nbsp;
        <a
          href="http://bgaconsultoria.com.br/"
          target="_blank"
        >BGA consultoria</a>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import menu from "../lib/menu";
export default {
  data() {
    return {
      itens: menu.itens
    };
  },
  computed: {
    ...mapState({
      perms: state => state.usuarios.usuarioAtivo.permissoes
    }),
    drawer: {
      get() {
        return this.$store.state.ui.drawer.open;
      },
      set(value) {
        this.$store.commit("ui/toggleDrawer", value);
      }
    }
  },
  methods: {
    permitido(item) {
      try {
        if (item.permissoes.length === 0) {
          return true;
        }
        for (let perm of item.permissoes) {
          if (this.perms.includes(perm)) {
            return true;
          }
        }
        return false;
      } catch (e) {
        return false;
      }
    }
  }
};
</script>

<style scoped>
.d3v-link a {
  text-decoration: none;
}
</style>
